<div class="panel">
    <div class="dashboard">
        <app-dashboard [usuarioPanel]="usuarioPanel"></app-dashboard>
    </div>
    <div class="panelContent">
        <app-header-panel [usuarioPanel]="usuarioPanel"></app-header-panel>
        <app-estudio-medico-form [estudioMedico]="estudioMedico" [editar]="editar"></app-estudio-medico-form>
    </div>
</div>
